/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { AppLink } from './AppLink.types.tsx';

export const servicedeskKnowledgeBaseAppLinksResource: RouteResource<AppLink[]> = createResource<
	AppLink[]
>({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_APP_LINKS',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-knowledge-base-app-links", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-app-links" */ './fetchAppLinks.tsx'
		),
	maxAge: Infinity,
});
